import React, { useState } from "react";
import {
  Box,
  TextField,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useCookies } from "../../../hooks/useCookies";

const themeSettings = {
  typography: {
    fontFamily: ['"Inter"', "sans-serif"].join(","),
    fontSize: 14,
  },
};

const theme = createTheme(themeSettings);

const AdminSignIn = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setCookie } = useCookies();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (username === "adminUser" && password === "X&>%cA9#%W2") {
      setCookie("Admintoken", "X&>%cA9#%W2", 315);
      navigate("/admin/user/approval");
    } else {
      setError("Login failed. Invalid credentials.");
    }

    setLoading(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100dvh"
        sx={{
          background: "linear-gradient(90deg, #FC8C66, #F76A7B)",
          backgroundSize: "cover",
          backgroundColor: "rgb(245, 245, 245)",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          p={4}
          sx={{
            width: { xs: "90%", sm: "70%", md: "50%", lg: "30%", xl: "25%" },
            backgroundColor: "#FFFFFF",
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <h5 style={{ textAlign: "center", marginBottom: "16px" }}>
              Admin Login
            </h5>

            <div className="row mb-2">
              <TextField
                fullWidth
                label="Username"
                variant="outlined"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="row mb-2">
              <TextField
                fullWidth
                label="Password"
                variant="outlined"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>

            {error && (
              <div className="row mb-2">
                <p style={{ color: "#f44336", fontSize: "0.875rem", margin: 0 }}>
                  {error}
                </p>
              </div>
            )}

            <div className="row mb-2 justify-content-center">
              <button
                type="submit"
                disabled={loading}
                className="global-next-btn"
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AdminSignIn;
